import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../components/auth/AuthRequiredRoute/AuthRequiredRoute";
import Button from "../../components/ui/Button/Button";
import { useLoanInfo } from "../../features/loans/hooks/useLoanInfo";
import HeaderComponent from "../Header/HeaderComponent";
import styles from "./style.module.css";

const CheckNewLoanPrincipal = () => {
  const navigate = useNavigate();

  const { loanId } = useParams();

  const { userData } = useAuth();

  const { loanInfo } = useLoanInfo({ loanId, userData });

  return (
    <div>
      <HeaderComponent
        onBack={() => {
          navigate("/my-loans");
        }}
        title="เอกสารสัญญาบริการใหม่"
      />
      <main className={styles.content}>
        <>
          <h2 className={styles.title}>รายการเลขที่ {loanInfo?.loan_name}</h2>
          <embed
            className={styles.pdf}
            src="/assets/loan-contract-example.pdf"
          />
          <footer className={styles.footer}>
            <Button
              onClick={() => {
                navigate("/my-loans");
              }}
              textColor={"#667085"}
              fullWidth
            >
              ยกเลิกคำขอ
            </Button>
            <Button
              onClick={() => {
                // setShowConfirmDialog(true);
              }}
              variant="primary"
              fullWidth
            >
              ยอมรับ
            </Button>
          </footer>
        </>
      </main>
    </div>
  );
};

export default CheckNewLoanPrincipal;
